<template>
  <div class="list">
    <ListView :on-infinite="onLoadMore" :hasMore="recordHasMore">
      <ListItem v-for="item in recordList" :key="item.orderno" @click.native="gotoDetail(item.orderno)" :item="item" />
      <template slot="load-done">
        <Nothing></Nothing>
      </template>
    </ListView>
    <EmptyListTip
      v-if="recordReady && recordList.length <= 0"
      :icon="require('../../assets/icon-empty-cart.png')"
      text="无充值记录"
    />
  </div>
</template>

<script>
import ListItem from "@/components/charge/ListItem";
import api from "../../api";

export default {
  bodyClass: "gray-bg",
  title: "话费充值账单",
  components: {
    ListItem
  },
  data() {
    return {
      lastId: "",
      hasMore: null,
      recordHasMore: true,
      recordReady: false,
      recordList: []
    };
  },
  methods: {
    gotoDetail(orderno) {
      this.$routerPush(this, `/pages/charge/Detail?orderno=${orderno}`);
    },
    onLoadMore(done) {
      this.loadRecordList(false, done);
    },
    loadRecordList(isNew, doneCb) {
      if (!doneCb) {
        doneCb = () => {};
      }
      if (isNew) {
        this.recordReady = false;
        this.recordList = [];
        this.recordHasMore = true;
      }
      this.$showLoading("加载中...");

      api.charge.getRecord(
        this.lastId,
        res => {
          res.records.forEach(element => {
            this.recordList.push(element);
          });

          this.recordHasMore = res.hasMore;
          this.lastId = res.lastId;
          this.recordReady = true;

          doneCb();
          this.$hideLoading();
        },
        r => {
          this.$alertDialog(r.msg);
          this.$hideLoading();
          doneCb();
        }
      );
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.list {
  padding: 4vw;
}
</style>


// WEBPACK FOOTER //
// src/pages/charge/List.vue